import { Component, inject, OnInit } from '@angular/core';
import { IonHeader, IonTitle, IonToolbar, IonContent, IonIcon } from "@ionic/angular/standalone";
import { LocalizationModule } from "../../../../modules/localization/localization.module";
import { SessionService } from 'src/app/services/session.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cancellation-confirmation',
  templateUrl: './cancellation-confirmation.component.html',
  styleUrls: ['./cancellation-confirmation.component.scss'],
  standalone: true,
  imports: [IonIcon, IonContent, IonToolbar, IonTitle, IonHeader, LocalizationModule, DatePipe]
})
export class CancellationConfirmationComponent {
  sessionService = inject(SessionService);
  subscriptionService = inject(SubscriptionService);
}
